import React, { useEffect, useState } from 'react';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Icon from '@mdi/react';
import { mdiCheck } from '@mdi/js';
import { Button, Input, Text } from 'design-system';
import { Mask, ResponsiveText } from 'UI';
import { CustomErrorBoundary } from 'utils';
import { useProfile } from 'hooks';
import './Username.scss';

const Username = ({ onClose, label }) => {
  const [newUsername, setNewUsername] = useState('');
  const [success, setSuccess] = useState(false);
  const { updateMe } = useProfile();

  async function handleSubmit(e) {
    await updateMe({
      variables: {
        input: {
          username: newUsername,
        },
      },
    });
    setSuccess(true);
  }

  useEffect(() => {
    disableBodyScroll();
    return () => {
      clearAllBodyScrollLocks();
    };
  }, []);

  return (
    <Mask
      className="username-mask disabled-click-event"
      onClose={onClose}
      withOverlay
    >
      <div className="username-modal">
        <div className="username-bloc">
          {!success && (
            <div className="form">
              <Text bold>Bienvenue par ici !</Text>
              <Text>{label}</Text>
              <Input
                type="text"
                placeholder=""
                value={newUsername}
                onChange={e => setNewUsername(e.target.value)}
              />
              <div className="username-buttons">
                <Button
                  label="Valider"
                  variant="primary"
                  onClick={handleSubmit}
                />
                <Button
                  label="Fermer"
                  variant="secondary"
                  onClick={() => {
                    onClose();
                    clearAllBodyScrollLocks();
                  }}
                />
              </div>
            </div>
          )}
          {success && (
            <div className="password-success">
              <Icon path={mdiCheck} size="40" />
              <ResponsiveText>Oh Wow super pseudo !</ResponsiveText>
              <ResponsiveText size="large" bold>
                Mangas.io 💘 {newUsername}
              </ResponsiveText>
              <Button
                label="Fermer"
                variant="primary"
                onClick={() => {
                  onClose();
                  clearAllBodyScrollLocks();
                }}
              />
            </div>
          )}
        </div>
      </div>
    </Mask>
  );
};

function UsernameError() {
  return null;
}
export default function UsernameWrapper(props) {
  return (
    <CustomErrorBoundary handleError={<UsernameError />}>
      <Username {...props} />
    </CustomErrorBoundary>
  );
}
